import { Box } from "@mui/material";
import React from "react";

import AnalyticsView from "../components/Analytics/AnalyticsView";
import Sidebar from "../components/Layout/Sidebar";

const AnalyticsPage: React.FC = () => (
  <Box
    sx={{
      display: "flex",
      height: "100vh",
      backgroundColor: "background.default",
      overflow: "hidden",
    }}
  >
    <Sidebar />
    {/* Positioned, so that the detail overlay can lie over this part */}
    <Box sx={{ flex: 1, minWidth: 0, height: "100%", position: "relative" }}>
      <AnalyticsView />
    </Box>
  </Box>
);

export default AnalyticsPage;
